"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ButtonConstants = require("./ButtonConstants");

var _UIButton = _interopRequireDefault(require("./UIButton"));

var UIFileButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(UIFileButton, _React$Component);

  function UIFileButton() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UIFileButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UIFileButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClick = function (evt) {
      var onClick = _this.props.onClick;

      _this._file.click();

      if (onClick) onClick(evt);
    };

    _this.fileRefCallback = function (ref) {
      _this._file = ref;
    };

    return _this;
  }

  (0, _createClass2.default)(UIFileButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          accept = _this$props.accept,
          Button = _this$props.Button,
          children = _this$props.children,
          id = _this$props.id,
          multiple = _this$props.multiple,
          onChange = _this$props.onChange,
          __onClick = _this$props.onClick,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["accept", "Button", "children", "id", "multiple", "onChange", "onClick"]);
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(Button, Object.assign({
        className: "private-file-button",
        "data-component-name": "UIFileButton",
        onClick: this.handleClick
      }, rest), children), _react.default.createElement("input", {
        className: "private-file-button__input hidden",
        id: id,
        ref: this.fileRefCallback,
        type: "file",
        accept: accept.join(','),
        multiple: multiple,
        onChange: onChange
      }));
    }
  }]);
  return UIFileButton;
}(_react.default.Component);

exports.default = UIFileButton;
UIFileButton.propTypes = {
  accept: _propTypes.default.array.isRequired,
  Button: _propTypes.default.elementType.isRequired,
  children: _propTypes.default.node.isRequired,
  multiple: _propTypes.default.bool.isRequired,
  onChange: _propTypes.default.func.isRequired,
  use: _propTypes.default.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired
};
UIFileButton.defaultProps = {
  accept: [],
  Button: _UIButton.default,
  multiple: false,
  use: 'tertiary-light'
};
UIFileButton.displayName = 'UIFileButton';
module.exports = exports.default;